<template>
  <span>{{ displayedText }}</span>
</template>

<script setup>
import {
  ref,
  watch,
  onBeforeUnmount
} from "vue";

const props = defineProps({
  text: {
    type: String,
    default: ""
  },

  speed: {
    type: Number,
    default: 25
  }
});

const displayedText = ref("");

let timer = null;

function stop() {
  if (timer !== null) {
    clearTimeout(timer);
    timer = null;
  }
}

function typeForward() {
  stop();

  const text = String(props.text || "");

  displayedText.value = "";

  if (!text) {
    return;
  }

  let index = 0;

  function next() {
    /*
     * Add one character only.
     * Characters are NEVER removed.
     */
    index++;

    displayedText.value =
      text.slice(0, index);

    /*
     * Finished:
     * leave the complete text displayed.
     */
    if (index >= text.length) {
      timer = null;
      return;
    }

    timer = window.setTimeout(
      next,
      props.speed
    );
  }

  next();
}

watch(
  () => props.text,
  () => {
    typeForward();
  },
  {
    immediate: true
  }
);

onBeforeUnmount(() => {
  stop();
});
</script>